"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthnicityAdminPage = void 0;
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const classifiers_1 = require("../../classifiers");
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            { label: t('common.status'), value: t(`classifiers.statusEnum.${props.response.data.status}`) },
            { label: t('classifiers.displayOrder'), value: (_a = props.response.data.displayOrder) !== null && _a !== void 0 ? _a : react_1.default.createElement("em", null, "(not set)") },
        ] }));
};
const csvFileHeader = ['ID', 'Name', 'Status', 'Display Order'];
function mapCsvRowToData(row) {
    var _a, _b, _c, _d;
    const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
    const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
    const status = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
    const displayOrder = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim();
    if (name.length === 0) {
        row.errors.push('Name is required');
    }
    if (status.length === 0) {
        row.errors.push('Status is required');
    }
    switch (status) {
        case 'active':
        case 'deprecated':
        case 'retired':
            break;
        default:
            row.errors.push('Invalid status, expected one of: active, deprecated, retired');
    }
    let displayOrderNumber;
    if (displayOrder) {
        displayOrderNumber = parseFloat(displayOrder);
        if (!isFinite(displayOrderNumber)) {
            row.errors.push('Invalid display number, expected a number');
            displayOrderNumber = undefined;
        }
    }
    if (row.errors.length === 0) {
        row.object = {
            id: id,
            data: {
                name: name,
                status: status,
                displayOrder: displayOrderNumber,
            },
        };
    }
    return Promise.resolve(row);
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return [
            response.id,
            response.data.name,
            response.data.status,
            response.data.displayOrder != null ? response.data.displayOrder.toString() : '',
        ];
    });
}
const EthnicityAdminPage = () => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const formConfig = (0, classifiers_1.useDefaultFormConfig)({ displayOrder: true });
    return (react_1.default.createElement(classifiers_1.ClassifierAdminPage, { entity: shared_1.ethnicityEntityName, title: t('defaultClassifiers.ethnicity'), fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
exports.EthnicityAdminPage = EthnicityAdminPage;
